import selfPracticeGrey from "apps/juno-client/public/selfPracticeGreyCircle.svg";
import selfPracticeBlack from "apps/juno-client/public/selfPracticeBlackCircled.svg";
import selfPracticeBlue from "apps/juno-client/public/selfPracticeBlueCircle.svg";

export const ACTIVITY_LIST_PERSIST_DELAY = 5000;

export const VIDEO_STATUSES = {
  DISCONNECTED: 0,
  ERROR: 1,
  CONNECTING: 2,
  PENDING: 3,
  APPROVED: 4,
};

export const SELF_PRACTICE_STATUSES = {
  ACTIVE: { id: 0, title: "practice active", icon: selfPracticeBlue },
  DRAFT: { id: 1, title: "draft", icon: selfPracticeBlack },
  FINISHED: { id: 2, title: "not active", icon: selfPracticeGrey },
  NOT_SET: { id: 3, title: "add practice", icon: selfPracticeBlack },
};
